import { useCurrentTracking } from './use-current-tracking';
export function useProducts() {
  var _pkg$products;

  var pkg = useCurrentTracking();
  return {
    products: (_pkg$products = pkg === null || pkg === void 0 ? void 0 : pkg.products) !== null && _pkg$products !== void 0 ? _pkg$products : []
  };
}